import React, { createElement, Fragment } from 'react';
import moduleCss from './index.module.scss';
import { Mask } from '@ifeng/lowcode_tool/src/components/Mask'
import { useChip, TYPE_Chip } from '@ifeng/lowcode_tool/src/hooks/useChip'
import { formatChip } from '@ifeng/lowcode_tool/src/method/chip'
import Chip from 'Chip';

export interface NewsList_1_Props {
    newsChip: TYPE_Chip;
    hoverColor: string;
    style?: object;
}

const NewsList_1: React.FC<NewsList_1_Props> = (props) => {
    const { newsChip, hoverColor, style } = props;

    const newsChipData = useChip(newsChip);
    const chipComponentData = formatChip(newsChip)

    return (
        <Chip {...chipComponentData}>
            <div className={moduleCss.newsList} style={style}>
                {newsChipData.map((item, index) => {
                    return (
                        <div className={moduleCss.news} key={index}>
                            {/*@ts-ignore*/}
                            <div className={moduleCss.title} style={{ '--color-hover': hoverColor }}>
                                <a href={item.url} target="_blank" rel="noreferrer">
                                    {item.title}
                                </a>
                            </div>
                            <div>
                                {item.children &&
                                    item.children
                                        .filter((a, i) => i % 2 === 0)
                                        .map((i, idx) => {

                                            return (
                                                <p key={idx}>
                                                {/*@ts-ignore*/}
                                                <span style={{ '--color-hover': hoverColor }}>
                                                    <a
                                                        href={item.children[2 * idx].url}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        {item.children[2 * idx].title}
                                                    </a>
                                                </span>
                                                    {item.children[2 * idx + 1] && (
                                                        <Fragment>
                                                            {' | '}
                                                            {/*@ts-ignore*/}
                                                            <span style={{ '--color-hover': hoverColor }}>
                                                            <a
                                                                href={
                                                                    item.children[2 * idx + 1].url
                                                                }
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                {item.children[2 * idx + 1].title}
                                                            </a>
                                                        </span>
                                                        </Fragment>
                                                    )}
                                                </p>
                                            );
                                        })}
                            </div>
                        </div>
                    );
                })}
                <Mask visible={!newsChip.id} zIndex={3}>示例推荐位碎片—{newsChip.default.id}</Mask>
            </div>
        </Chip>
    );
};

export default NewsList_1;
